module.exports = (s) => {
  return [
    {
      name: '小游戏appid',
      value: 'micro_app_id',
    },
    {
      name: '小游戏链接备注',
      value: 'link_remark',
    },
    {
      name: '小游戏链接',
      value: 'link',
    },
    {
      name: '操作',
      width: 90,
      align: 'center',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                s.confirm(row);
              },
            },
          },
          '选择',
        );
        return ele;
      },
    },
  ];
};
